module.exports = __webpack_public_path__ + "mobileshop.5cea1972.png";